"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const _1 = require(".");
const pipeable_1 = require("fp-ts/lib/pipeable");
function dateWithinRange(path, start, end) {
    return (value) => pipeable_1.pipe(dateSameOrBefore(path, end)(value), E.chain(dateSameOrAfter(path, start)), E.mapLeft(() => [
        new _1.ValidationError(path, `${value.format()} not within ${start.format()} - ${end.format()}`, new DateWithinRangeInfo(value.format(), start.format(), end.format())),
    ]));
}
exports.dateWithinRange = dateWithinRange;
class DateWithinRangeInfo {
    constructor(actual, start, end) {
        this.actual = actual;
        this.start = start;
        this.end = end;
        this.type = 'dateWithinRange';
    }
}
function dateSameOrAfter(path, start) {
    return (value) => {
        if (start.isAfter(value)) {
            return E.left([
                new _1.ValidationError(path, `${value.format()} not same or after ${start.format()}`, new DateSameOrAfterInfo(value.format(), start.format())),
            ]);
        }
        return E.right(value);
    };
}
exports.dateSameOrAfter = dateSameOrAfter;
class DateSameOrAfterInfo {
    constructor(actual, start) {
        this.actual = actual;
        this.start = start;
        this.type = 'dateSameOrAfter';
    }
}
function dateSameOrBefore(path, start) {
    return (value) => {
        if (value.isAfter(start)) {
            return E.left([
                new _1.ValidationError(path, `${value.format()} not same or before ${start.format()}`, new DateSameOrBeforeInfo(value.format(), start.format())),
            ]);
        }
        return E.right(value);
    };
}
exports.dateSameOrBefore = dateSameOrBefore;
class DateSameOrBeforeInfo {
    constructor(actual, start) {
        this.actual = actual;
        this.start = start;
        this.type = 'dateSameOrBefore';
    }
}
function dateAfter(path, start) {
    return (value) => {
        if (value.isAfter(start)) {
            return E.right(value);
        }
        return E.left([
            new _1.ValidationError(path, `${value.format()} not after ${start.format()}`, new DateAfterInfo(value.format(), start.format())),
        ]);
    };
}
exports.dateAfter = dateAfter;
class DateAfterInfo {
    constructor(actual, start) {
        this.actual = actual;
        this.start = start;
        this.type = 'dateAfterInfo';
    }
}
function dateEqual(path, start) {
    return (value) => {
        if (start.isEqual(value)) {
            return E.right(value);
        }
        return E.left([
            new _1.ValidationError(path, `${value.format()} not equal ${start.format()}`, new DateEqualInfo(value.format(), start.format())),
        ]);
    };
}
exports.dateEqual = dateEqual;
class DateEqualInfo {
    constructor(actual, start) {
        this.actual = actual;
        this.start = start;
        this.type = 'dateEqual';
    }
}
function timeSameOrAfter(path, start) {
    return (value) => {
        if (start.isAfter(value)) {
            return E.left([
                new _1.ValidationError(path, `${value.format()} not same or after ${start.format()}`, new TimeSameOrAfterInfo(value.format(), start.format())),
            ]);
        }
        return E.right(value);
    };
}
exports.timeSameOrAfter = timeSameOrAfter;
class TimeSameOrAfterInfo {
    constructor(actual, start) {
        this.actual = actual;
        this.start = start;
        this.type = 'timeSameOrAfter';
    }
}
function timeSameOrBefore(path, start) {
    return (value) => {
        if (value.isAfter(start)) {
            return E.left([
                new _1.ValidationError(path, `${value.format()} not same or before ${start.format()}`, new TimeSameOrBeforeInfo(value.format(), start.format())),
            ]);
        }
        return E.right(value);
    };
}
exports.timeSameOrBefore = timeSameOrBefore;
class TimeSameOrBeforeInfo {
    constructor(actual, start) {
        this.actual = actual;
        this.start = start;
        this.type = 'timeSameOrBefore';
    }
}
